const Show = ({ children, when = () => false }) => {
  if (!when()) {
    return <></>
  }

  return <>{children}</>
}

export default Show
